import { useAuthContext } from '@/context/AuthContext';
import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';

const UPDATE_USER_PERSONAL_IBAN = gql`
  mutation EditInformationUser_iban($iban: String!) {
    updateProfile(updatedProfile: { iban: $iban }) {
      iban
    }
  }
`;

const UPDATE_USER_PERSONAL_BIC_CODE = gql`
  mutation EditInformationUser_bicCode($bicCode: String!) {
    updateProfile(updatedProfile: { bicCode: $bicCode }) {
      bicCode
    }
  }
`;
const UPDATE_USER_PHONE_NUMBER = gql`
  mutation EditInformationUser_bicCode($phoneNumber: String!) {
    updateProfile(updatedProfile: { phoneNumber: $phoneNumber }) {
      phoneNumber
    }
  }
`;


const UPDATE_USER_PERSONAL_EMAIL = gql`
  mutation EditInformationUser_personalEmail($personalEmail: String!) {
    updateProfile(updatedProfile: { personalEmail: $personalEmail }) {
      personalEmail
    }
      
  }
`;

const UPDATE_USER_PERSONAL_ADDRESS = gql`
  mutation EditInformationUser_address($addressLine1: String!, $addressLine2: String, $zipCode: String!, $city: String!, $countryCode: String!) {
    updateProfile(updatedProfile: { addressLine1: $addressLine1, addressLine2: $addressLine2, zipCode: $zipCode, city: $city, countryCode: $countryCode }) {
      addressLine1
      addressLine2
      city
      zipCode
    }
  }
`;

const UPDATE_USER_LANGUAGE = gql`
  mutation EditInformationUser_language($language: InterfaceLanguage!) {
    updateProfile(updatedProfile: { language: $language }) {
      language
    }
  }
`;

export const useUpdateProfile = () => {

    const [updateIban, { loading: loadingIban, error: errorIban, data: dataIban }] = useMutation(UPDATE_USER_PERSONAL_IBAN);

    const [updateBicCode, { loading: loadingBicCode, error: errorBicCode, data: dataBicCode }] = useMutation(UPDATE_USER_PERSONAL_BIC_CODE);

    const [updateAddress, { loading: loadingAddress, error: errorAddress, data: dataAddress }] = useMutation(UPDATE_USER_PERSONAL_ADDRESS);

    const [updatePhoneNumber, { loading: loadingPhoneNumber, error: errorPhoneNumber, data: dataPhoneNumber }] = useMutation(UPDATE_USER_PHONE_NUMBER);

    const [updatePersonalEmail, { loading: loadingPersonalEmail, error: errorPersonalEmail, data: dataPersonalEmail }] = useMutation(UPDATE_USER_PERSONAL_EMAIL);

    const [updateLanguage] = useMutation(UPDATE_USER_LANGUAGE, {
        onError: (error) => {
            console.error(error);
        },
    });

    const setLanguage = async (language) => {
        try {
            const { data } = await updateLanguage({
                variables: { language },
            });
            return { data: data, error: null };
        } catch (err) {
            return { data: null, error: err.message };
        }
    };

    return {
        updateIban,
        updateBicCode,
        updateAddress,
        updatePhoneNumber,
        updatePersonalEmail,
        setLanguage,
        loadingIban,
        errorIban,
        dataIban,
        loadingBicCode,
        errorBicCode,
        dataBicCode,
        loadingAddress,
        errorAddress,
        dataAddress,
        loadingPhoneNumber,
        errorPhoneNumber,
        dataPhoneNumber,
        loadingPersonalEmail,
        errorPersonalEmail,
        dataPersonalEmail,
    };
};
